import type { IListItem } from './listItem.js';
export type DisplayStatusKind = 'on-track'|'delayed'|'overdue'|'completed'|'rejected'|'for-review'|'planned'|'blocked';
export interface IDisplayStatus { kind: DisplayStatusKind; labelKey: string; tone: 'ok'|'warn'|'danger'|'done'|'neutral'|'review'; days?: number; }
const dayDiff = (a: string, b: string) => Math.round((Date.parse(b) - Date.parse(a)) / 86_400_000);
export function deriveDisplayStatus(item: IListItem, today: string): IDisplayStatus {
  if (item.kind === 'issue') {
    if (item.status === 'completed') return { kind:'completed', labelKey:'activities.pill.completed', tone:'done' };
    if (item.status === 'rejected')  return { kind:'rejected',  labelKey:'activities.pill.rejected',  tone:'danger' };
    if (item.isOverdue)              return { kind:'overdue',   labelKey:'activities.pill.overdue',   tone:'danger' };
    if (item.status === 'forReview') return { kind:'for-review',labelKey:'activities.pill.forReview', tone:'review' };
    return { kind:'planned', labelKey:'activities.pill.planned', tone:'neutral' };
  }
  // A task is finished when a person marked it `done`, or Trusstor reports its
  // activity `complete`, or its progress reached 100 %.
  if (item.status === 'done' || item.activityStatus === 'complete' || (item.progressPercent ?? 0) >= 100)
    return { kind:'completed', labelKey:'activities.pill.completed', tone:'done' };
  if (item.status === 'blocked') return { kind:'blocked', labelKey:'activities.pill.blocked', tone:'danger' };
  if (item.isOverdue) return { kind:'overdue', labelKey:'activities.pill.overdue', tone:'danger' };
  if (item.start && item.end && typeof item.progressPercent === 'number') {
    const span = Math.max(1, dayDiff(item.start, item.end));
    const elapsed = Math.max(0, Math.min(1, dayDiff(item.start, today) / span));
    const daysBehind = Math.round((elapsed - item.progressPercent / 100) * span);
    if (daysBehind >= 1) return { kind:'delayed', labelKey:'activities.pill.delayed', tone:'warn', days: daysBehind };
  }
  return { kind:'on-track', labelKey:'activities.pill.onTrack', tone:'ok' };
}
